<template>
  <section class="block-about about">
    <div class="about__gallery">
      <!--       <img
        src="../images/bg/shape-top.svg"
        alt=""
        class="about__gallery-shape about__gallery-shape-top"
      /> -->

      <div class="about__arrow arrow-left"></div>
      <div class="about__arrow arrow-right"></div>
      <div class="swiper-container about-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="slide in slides" :key="slide">
            <div class="swiper-lazy" :data-background="getSlideImg(slide)">
              <div class="swiper-lazy-preloader"></div>
            </div>
          </div>
        </div>
      </div>

      <!--       <img
        src="../images/bg/shape-bottom.svg"
        alt=""
        class="about__gallery-shape about__gallery-shape-bottom"
      /> -->
    </div>
    <div class="about__content">
      <h2 class="about__title title">ФитнесМания – это</h2>
      <ul class="about__list">
        <li
          class="about__list-item"
          v-for="(item, i) in about_list"
          :key="i"
          v-html="item"
        ></li>
      </ul>
      <button
        class="about__btn button button_theme_primary"
        @click="
          getCall({ type: 'sale', form: 'about', title: 'Узнать больше' })
        "
      >
        <span>Узнать больше</span>
      </button>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";
import Swiper from "swiper";

export default {
  name: "block-about",
  mixins: [Mixin],
  data() {
    return {
      swiper: null,
      slides: 4,
      about_list: [
        "200 тренажёров Technogym",
        "Современная cycle-студия",
        "Зона функционального тренинга",
        "Просторная кардиозона",
        "Более 20 видов групповых программ",
        "Финаская сауна и солярий",
        "В 1 минуте от метро Фрунзенская",
        // "Тренажёрный зал, оснащённый тренажерами одного из лучших <br> брендов Technoqym",
        // "Кардиозона с функцией Unity 3.0. Смотри кино, общайся <br> с родными в социальных сетях, соревнуйся с друзьями, <br>слушай музыку.",
        // "Первая в России уникальная зона функционального тренинга <br> с рамой OutRace.",
        // "Зона TeamBeats, оснащенная тренажерами Skillmill u Skillrow.",
        // "Зона свободных весов и силового оборудования.",
        // "Зона сайкла с лучшими в мире тренерами.",
        // "Студии групповых программ.",
        // "Просторные раздевалки с соляриями и саунами. ",
      ],
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.about-swiper`, {
        autoplay: {
          delay: 3000,
        },
        lazy: true,
        loop: true,
        simulateTouch: true,
        navigation: {
          nextEl: `.arrow-right`,
          prevEl: `.arrow-left`,
        },
      });
    },
    getSlideImg(img) {
      return require(`../images/slides/${img}.jpg`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.about-swiper {
  //clip-path: polygon(0 14%, 100% 0%, 100% 86%, 0% 100%);
}

.about {
  display: flex;
  align-items: center;

  &__gallery {
    width: 50%;
    position: relative;
  }

  &__gallery-shape {
    width: 101%;
    position: absolute;
    right: 0;
    left: 0;
    z-index: 2;
    pointer-events: none;

    &-top {
      top: 48px;
      left: -2px;
    }

    &-bottom {
      bottom: -2px;
    }
  }

  .swiper-lazy {
    width: 100%;
    height: calc(100vw * 653 / 1440);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  &__content {
    width: 50%;
    padding-left: 40px;
    padding-right: 24px;
  }

  &__title {
    line-height: 0.72;
  }

  &__list {
    margin-top: 42px;
    list-style: none;
  }

  &__list-item {
    font-family: Brush Script MT, Roboto, sans-serif;
    font-style: italic;
    margin-top: 24px;
  }

  &__btn {
    max-width: 207px;
    margin-top: 30px;
    font-size: 20px;
  }

  &-swiper {
    margin-top: 48px;
    margin-right: 8px;
  }

  &__arrow {
    position: absolute;
    bottom: 8px;
    width: 30px;
    height: 34px;
    z-index: 5;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    outline: none;

    &:active {
      opacity: 0.5;
    }

    &.arrow-right {
      background-image: url("../images/utils/arrow-right.svg");
      right: 0;
    }

    &.arrow-left {
      background-image: url("../images/utils/arrow-left.svg");
      right: 9%;
    }
  }
}

@media (max-width: 1200px) {
  .about {
    &__content {
      padding-left: 20px;
    }

    &__list-item {
      margin-top: 16px;
    }

    &__btn {
      height: 44px;
      font-size: 14px;
      margin-top: 24px;
    }

    &__arrow {
      width: 10px;
      height: 18px;
    }
  }
}

@media (max-width: 900px) {
  .about {
    // transform: translateY(-14%);

    .swiper-lazy {
      height: 365px;
    }
  }
}

@media (max-width: 768px) {
  .about-swiper {
    //clip-path: polygon(0 20%, 100% 0%, 100% 80%, 0% 100%);
  }

  .about {
    flex-direction: column;

    &__gallery {
      width: 100%;
    }

    &__content {
      width: 100%;
      padding-top: 30px;
      padding-left: 24px;
    }

    &__list-item {
      font-size: 14px;
    }

    &__arrow {
      &.arrow-right {
        right: 8px;
      }

      &.arrow-left {
        right: 15%;
      }
    }
  }
}

@media (max-width: 450px) {
  .about {
    &__content {
      padding-left: 8px;
      padding-right: 8px;
    }

    .swiper-lazy {
      height: 319px;
    }

    &__btn {
      max-width: 100%;
    }
  }
}
</style>
